import { useAppMutation } from "../../http/useAppMutation.ts";
import { trackEvent } from "../../tracking/tracking.ts";
import { saveReturnPath } from "../../utils/returnPath.ts";

export const useCreatePaymentCheckoutUrl = () => {
  const {
    mutate: createPaymentCheckoutUrl,
    isLoading: isCreatePaymentCheckoutUrlLoading,
  } = useAppMutation<{ url: string }>({
    path: "payments/create-payment-checkout-url",
    invalidate: [],
    onSuccess: (response) => {
      if (response.data.url) window.open(response.data.url, "_self");
      trackEvent("one_time:start_checkout", {
        stripe_product: "additional_credits",
      });
    },
  }).mutation;

  return {
    createPaymentCheckoutUrl: ({
      workspaceUuid,
      contentUuids,
      modelUuids,
    }: {
      workspaceUuid: string;
      contentUuids?: string[];
      modelUuids?: string[];
    }) => {
      saveReturnPath();
      createPaymentCheckoutUrl({
        workspace_uuid: workspaceUuid,
        content_uuids: contentUuids,
        reference_uuids: modelUuids,
      });
    },
    isCreatePaymentCheckoutUrlLoading,
  };
};
